<template>
    <div class="swiper-container" :id="options.id" :style="swiperStyle">
        <div class="swiper-wrapper">
            <!-- banner -->
            <template v-if="options.id == 'swiper-banner'">
                <div v-for="item in bannerList" :key="item.id" class="swiper-slide blue-slide">
                    <img :src="item.image">
                </div>
            </template>

            <template v-else-if="options.id == 'swiper-index-news'">
                <router-link 
                    v-for="item in bannerList" 
                    :key="item.id" :to="`${$params.baseDir}news/detail/${item.id}?typeId=${item.category_id}`"  
                    class="swiper-slide blue-slide">
                    <img :src="item.picture" />
                    <div class="slide-text">{{item.title}}</div>
                </router-link>
            </template>

            <template v-else-if="options.id == 'swiper-train-news'">
                <router-link 
                    v-for="item in bannerList" 
                    :key="item.id" :to="`${$params.baseDir}train/news-detail/${item.id}?typeId=${item.category_id}`"  
                    class="swiper-slide blue-slide">
                    <img :src="item.picture" />
                    <div class="slide-text">{{item.title}}</div>
                </router-link>
            
            </template>
            

        </div>
        <!--左右箭头。如果放置在swiper外面，需要自定义样式。-->
        <template v-if="options.navigation">
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
        </template>
        <!--分页-->
        <div v-if="options.showPage" class="test swiper-pagination" 
            :class="[options.paginationClass ? options.paginationClass : '']" 
            :id="this.options.id + 'pagination'">
        </div>
    </div>
</template>
<script>

import Swiper from 'swiper'
import "swiper/css/swiper.css"
export default {
    data() {
        return {
            swiperStyle: {},
            showText: false,
            showPage: false,
            mySwiper: {}
        }
    },
    props: {
        bannerList: Array,
        options: Object,
    },
    created() {
        if (this.options) {
            if (this.options.width)
                this.swiperStyle.width = this.options.width + 'px'
            if (this.options.height)
                this.swiperStyle.height = this.options.height + 'px'
            if (this.options.showText)
                this.showText = this.options.showText
            if (this.options.showPage)
                this.showPage = this.options.showPage
        }
    },
    mounted() {
        this._initSwiper()
    },
    beforeDestroy(){
        //this.mySwiper.disable()
    },
    methods: {
        handleClick(e){
            const current = e.target
            if(current.attributes["index"]){                // 跳转到指定的 swiper 页面
                const toCount = current.attributes["index"].value || ''
                if (toCount)
                    this.mySwiper.slideTo(toCount)
            }
        },
        _initSwiper() {   //初始化swiper插件
            this.$nextTick(() => {
                let options = {
                    speed: 1000,
                    loop: false,
                    disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
                    observer: true,//修改swiper自己或子元素时，自动初始化swiper
                    observeParents: true,//修改swiper的父元素时，自动初始化swiper
                }
                options = {...options, ...this.options}
                if(this.options.navigation){
                    options.navigation = {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }
                }
                    
                if (this.options && this.options.showPage) {
                    options.pagination = { //分页器
                        el: ".swiper-pagination",
                        clickable: true,
                    }
                    if(this.options.id == 'swiper-index-news'){
                        options.pagination = { //分页器
                            el: ".swiper-pagination",
                            clickable: true,
                            type: 'custom',
                            renderCustom: function (swiper, current, total) {
                                var customPaginationHtml = "";
                                //console.log(total)
                                for (var i = 0; i < total; i++) {
                                    //console.log(i)
                                    //判断哪个分页器此刻应该被激活 
                                    if (i == (current - 1)) {
                                        customPaginationHtml += '<span class="cpointer swiper-pagination-customs swiper-pagination-customs-active" index=' + (i + 1) + '>' + (i + 1) + '</span>';
                                    } else {
                                        customPaginationHtml += '<span class="cpointer swiper-pagination-customs" index=' + (i + 1) + '>' + (i + 1) + '</span>';
                                    }
                                }
                                return customPaginationHtml;
                            }
                        }
                    }
                
                }
                this.mySwiper = new Swiper("#" + this.options.id, options)

                this.customBox = document.getElementById(this.options.id + 'pagination')
                if(this.customBox){
                    this.customBox.addEventListener('click', this.handleClick, false)
                }
                   
            })
        }
    }
}
</script>
<style scope>
.swiper-container {
    overflow: hidden;
    /* height: 400px; */
}

.swiper-container {
    --swiper-theme-color: #ff6600;
    --swiper-pagination-color: #333;
}

.swiper-container .swiper-slide {
    height: 100% !important;
}

.swiper-container img {
    display: block;
    width: 100%;
    height: 100%;
}

.slide-text {
    position: absolute;
    bottom: -2px;
    padding: 0 0 0 0;
    width: 100%;
    height: 40px;
    line-height: 40px;
    background: #fff;
    font-size: 16px;

}

.swiper-pagination {
    padding-right: 10px;
    text-align: right;
}

.swiper-pagination-bullet {
    margin: 0 5px;
    width: 12px;
    height: 12px;
    background: #fff;
    opacity: 1;
}

.swiper-pagination-bullet-active {
    background: #ff0000;
}

#swiper-banner:hover .swiper-button-prev,
#swiper-banner:hover .swiper-button-next{
    opacity: 1;
}
#swiper-banner .swiper-button-prev,
#swiper-banner .swiper-button-next {
    width: 70px;
    height: 110px;
    background: rgba(0, 0, 0, .3);
    left: 50%;
    opacity: 0;
    transition: all .5s;
}

#swiper-banner .swiper-button-prev {
    margin-left: -700px;
}

#swiper-banner .swiper-button-next {
    margin-left: 665px;
}

#swiper-banner .swiper-button-prev::after,
#swiper-banner .swiper-button-next::after {
    font-weight: bold;
    font-size: 60px;
    color: #fff;
}

.swiper-pagination{
    bottom: 50px;
}
.swiper-pagination-customs{
    margin: 0 2px;
    display: inline-block;
    text-align: center;;
    width: 22px;
    height: 22px;
    line-height: 20px;
    background: rgba(102,102,102,.2);
    border: 1px solid #c4bec0;
    font-size: 12px;
    color: #fff;
}
.swiper-pagination-customs-active{
    background: #ba0c11;
    border-color: #fff;
    color: #fff;
}


#swiper-train-news .slide-text {
    position: absolute;
    bottom: -2px;
    padding: 0 10px;
    width: 100%;
    height: 40px;
    line-height: 40px;
    background: rgba(0,0,0,.3);
    color: #fff;
    font-size: 16px;

}
#swiper-train-news .swiper-pagination-bullet {
    margin: 0 5px;
    width: 25px;
    height: 7px;
    background: #fff;
    border-radius: 0;
    opacity: 1;
}

#swiper-train-news .swiper-pagination-bullet-active {
    background: #efcb3a;
}
#swiper-train-news:hover .swiper-button-prev,
#swiper-train-news:hover .swiper-button-next{
    opacity: 1;
}
#swiper-train-news .swiper-button-prev,
#swiper-train-news .swiper-button-next {
    width: 48px;
    height: 72px;
    background: rgba(0, 0, 0, .3);
    /* left: 50%; */
    opacity: 0;
    transition: all .5s;
    color: #fff;
}
#swiper-banner .swiper-pagination{
    text-align: center;
    bottom: 20px;
}
#swiper-banner .swiper-pagination span{
    background: rgba(0, 0, 0, .4);
    width: 10px;
    height: 10px;
}
#swiper-banner .swiper-pagination .swiper-pagination-bullet-active{
    background: #fff;
    border-radius: 5px;
    width: 25px;
}
</style>